// Common
import { ReactElement} from 'react'

// Components
import Col from 'shared-components/col'
import Typography from 'shared-components/typography'

type IProps = {
	error: string
}

export default function Errors(props: IProps): ReactElement {
	return (
		<Col style={{ alignItems: 'center' }}>
			<Typography
				style={{
					color: 'red',
					padding: '0 20px',
					textAlign: 'center',
					fontSize: '12px',
					alignItems: 'center',
				}}
			>
				{props.error}
			</Typography>
		</Col>
	)
}
